import Flex from '@Components/Bases/Flex';
import { useDisclosure } from '@hooks/useDisclosure';
import { Add } from '@mui/icons-material';
import { Button, InputLabel, Typography } from '@mui/material';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import { ICarbonDetailFormValues } from '../../EsgGreenhouseFormProvider/types';
import { useGreenhouseGoalTerm } from '../GreenhouseGoalTermProvider/GreenhouseGoalTermProvider';
import CarbonNeutralityTable from './CarbonNeutralityTable/CarbonNeutralityTable';
import ModalCarbonNeutrality from './ModalCarbonNeutrality/ModalCarbonNeutrality';

const CarbonNeutralityDetail = () => {
  const {
    formState: { errors },
  } = useGreenhouseForm();
  const [opened, { open, close }] = useDisclosure();
  const { ghGasScope } = useGreenhouseGoalTerm();

  const [carbonDetails, completedSection] = useWatch({
    name: [
      'greenhouseGoalTerm.carbon.details',
      'greenhouseGoalTerm.completedSection',
    ],
  }) as [ICarbonDetailFormValues[] | undefined, CompleteSectionFormValues];

  const prevScopeIds = carbonDetails?.map((detail) => detail.scopeId);
  const scopeExists = ghGasScope?.filter(
    (option) => !prevScopeIds?.includes(option.id)
  );
  const { isCompletedTh, isCompletedEn } = completedSection ?? {};
  const carbonError = errors.greenhouseGoalTerm?.carbon?.details;

  return (
    <>
      <Flex justifyContent={'space-between'} alignItems={'center'} my={2}>
        <InputLabel required sx={{ fontWeight: 'bold' }}>
          การตั้งเป้าหมายความเป็นกลางทางคาร์บอน (Carbon Neutrality)​
        </InputLabel>
        <Button
          color={'inherit'}
          startIcon={<Add />}
          onClick={open}
          disabled={scopeExists?.length === 0 || isCompletedTh || isCompletedEn}
        >
          เพิ่มข้อมูล
        </Button>
      </Flex>
      <CarbonNeutralityTable />
      {carbonError && (
        <Typography mt={2} variant={'caption'} color={'error.main'}>
          {carbonError.message}
        </Typography>
      )}
      {opened && (
        <ModalCarbonNeutrality open={opened} close={close} mode={'create'} />
      )}
    </>
  );
};

export default CarbonNeutralityDetail;
